import { render, staticRenderFns } from "./gongjian.vue?vue&type=template&id=b31f2742&scoped=true&"
import script from "./gongjian.vue?vue&type=script&lang=js&"
export * from "./gongjian.vue?vue&type=script&lang=js&"
import style0 from "./gongjian.vue?vue&type=style&index=0&id=b31f2742&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31f2742",
  null
  
)

export default component.exports